import { client } from './epic'

export const variation = feature => {
  if (client) {
    return client.getTreatment(feature)
  } else {
    console.warn(`split-io client unavailable - assuming control treatment for ${feature}`)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/experiment/helpers.js